enum Tab {
  Portfolios = 'portfolios',
  Teams = 'teams',
  Boards = 'boards',
  Agents = 'agents',
}

enum ChartType {
  Line = 'line',
  Bar = 'bar',
}

enum ViewMode {
  MeasureComparison = 'measure_comparison',
  Capacity = 'capacity',
  InitiativeOverview = 'initiative_overview',
  InitiativeCompletion = 'initiative_completion',
  InitiativeFocus = 'initiative_focus',
}

enum ComparisonMode {
  Single = 'single',
  Multiple = 'multiple',
}

enum MultipleViewMode {
  MonthlyAverages = 'monthly_averages',
  KeyMeasuresOverTime = 'key_measures_over_time',
  Capacity = 'capacity',
}

enum MetricType {
  WorkUnits = 'work_units',
  Points = 'points',
}

type ChartDataset = {
  id: string;
  name: string;
  data: number[];
  color: string;
  type: 'line' | 'bar';
};

type ChartData = {
  labels: string[];
  datasets: ChartDataset[];
};

type ProcessAnalysisFloraData = {
  data: Record<string, unknown>[];
  prompt: string;
  tooltip: string;
};

export { ChartType, ComparisonMode, MetricType, MultipleViewMode, Tab, ViewMode };
export type { ChartData, ProcessAnalysisFloraData };
